import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

/* Rounded X Icon */
const RoundedCloseIcon = (props) => (<SvgIcon {...props}>
    <path stroke="null" id="svg_1" d="m7.077441,12.9218c-3.640754,0 -6.605,-2.868 -6.605,-6.396c0,-3.525 2.963213,-6.395 6.605,-6.395c3.64282,0 6.605,2.869 6.605,6.395c-0.001033,3.528 -2.96218,6.396 -6.605,6.396zm0,-1.433c1.14645,0 2.202011,-0.371 3.056168,-0.988l-3.056168,-2.959l-3.056168,2.959c0.85519,0.617 1.909718,0.988 3.056168,0.988zm-5.12391,-4.962c0,1.11 0.38215,2.132 1.020444,2.96l3.056168,-2.959l-3.056168,-2.96c-0.638294,0.828 -1.020444,1.85 -1.020444,2.959zm5.12391,-4.961c-1.145417,0 -2.200978,0.371 -3.056168,0.988l3.056168,2.96l3.056168,-2.96c-0.854157,-0.617 -1.909718,-0.988 -3.056168,-0.988zm4.103466,2.002l-3.056168,2.96l3.056168,2.959c0.637261,-0.828 1.020444,-1.85 1.020444,-2.96c0,-1.109 -0.383183,-2.131 -1.020444,-2.959z"/>
    </SvgIcon>
);

export default RoundedCloseIcon;



// WEBPACK FOOTER //
// ./src/icons/RoundedCloseIcon.jsx